document.addEventListener('DOMContentLoaded', () => {
  const customForms = document.querySelectorAll('.custom-product-options');

  customForms.forEach((customForm) => {
    let formData = getCustomFormData(customForm);
    changeButtonPrice(customForm);

    customForm.addEventListener('change', () => {
      formData = getCustomFormData(customForm);
      setActiveLabel(customForm);
      changeButtonPrice(customForm);
    });

    customForm.addEventListener('submit', (e) => {
      e.preventDefault();
      formData = getCustomFormData(customForm);
      addToCartCustom(formData, customForm);
    });
  });
});

function getCustomFormData(customForm) {
  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  let variantId = checkedInput.dataset.variantId;
  let sellingPlanId = checkedInput.dataset.sellingPlan;
  let quantitySelectorInput = checkedLabel.querySelector('.custom-product-options__qty input[type="number"]');
  let quantity = 1
  if (quantitySelectorInput) {
    quantity = quantitySelectorInput.value;
  }

  let formData = {
    'items': [{
      'id': +variantId,
      'quantity': +quantity || 1,
      'selling_plan': +sellingPlanId || ''
    }],
    sections: "cart-popup,header"
  };

  return formData;
}

function setActiveLabel(customForm) {
  let allLabel = customForm.querySelectorAll('label.custom-product-options__item');
  allLabel.forEach(label => {
    label.classList.remove('active');
  });

  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  checkedLabel.classList.add('active');
}

function changeButtonPrice(customForm) {
  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  let checkedPrice = checkedLabel.querySelector('.custom-product-options__price');
  let buttonPrice = customForm.querySelector('.custom-product-options__submit-btn .custom-product-options__submit-btn-price');
  let stickyButtonPrice = document.querySelector('.custom-product-sticky-submit-btn .custom-product-options__submit-btn-price');

  if (!checkedPrice || !buttonPrice) return;

  buttonPrice.innerHTML = checkedPrice.innerHTML;
  const originInButton = buttonPrice.querySelector('.custom-product-options__price-origin');
  const originInSource = checkedPrice.querySelector('.custom-product-options__price-origin');
  if (originInButton && originInSource) {
    originInButton.innerHTML = originInSource.innerHTML;
  }

  if (stickyButtonPrice) {
    stickyButtonPrice.innerHTML = checkedPrice.innerHTML;
  }
}

async function addToCartCustom(formData, customForm) {
  const cartDrawer = document.querySelector('cart-drawer');
  const submitButton = customForm
    ? customForm.querySelector('.custom-product-options__submit-btn')
    : document.querySelector('.custom-product-options__submit-btn');
  
  if (submitButton) {
    submitButton.classList.add('btn--loading');
    submitButton.setAttribute('aria-disabled', true);
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...formData,
        sections: ['cart-drawer', 'header'],
        section_url: window.location.pathname
      })
    });
    const data = await response.json();

    if (response.ok) {
      // Get updated cart data
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartResponse.json();
      cartData.sections = data.sections;

      // Update cart state
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: cartData
        }
      }));

      // Dispatch product added event
      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: {
          product: data
        }
      }));

      // Dispatch cart drawer refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: {
          cart: cartData
        }
      }));

      // Show cart count
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cartData.item_count;
      }
      setTimeout(() => {
        const swiper = new Swiper('.cart-upsell-products', {
          slidesPerView: "auto",
          spaceBetween: 10,
          breakpoints: {
            
          }
        })
        console.log('Swiper initialized successfully');
      }, 1000);
      // Show cart drawer
      if (cartDrawer) {
        cartDrawer.show(submitButton);
      }
    } else {
      // Handle error
      document.dispatchEvent(new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: data.description
        }
      }));
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    document.dispatchEvent(new CustomEvent('product-ajax:error', {
      detail: {
        errorMessage: 'An error occurred while adding the product to cart.'
      }
    }));
  } finally {
    if (submitButton) {
      submitButton.classList.remove('btn--loading');
      submitButton.removeAttribute('aria-disabled');
    }
  }
}

function increaseQuantityCustom(button) {
  button.previousElementSibling.value = ++button.previousElementSibling.value;
}

function decreaseQuantityCustom(button) {
  if (button.nextElementSibling.value <= 1) {
    button.nextElementSibling.value = 1;
  } else {
    button.nextElementSibling.value = --button.nextElementSibling.value;
  }
}